import { render } from "./BaseError.vue?vue&type=template&id=f48f298e"
import script from "./BaseError.vue?vue&type=script&lang=js"
export * from "./BaseError.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__